import type { MouseEventHandler, Ref } from "react";
import { IconButton, type IconButtonProps } from "@mui/material";
import ArrowIcon from "../ArrowIcon/ArrowIcon";

interface ToggleExpandButtonProps extends Omit<IconButtonProps, "onClick"> {
  isToggled?: boolean;
  onClick: MouseEventHandler<HTMLButtonElement> | undefined;
  ref?: Ref<HTMLButtonElement | null>;
}

const ToggleExpandButton = ({
  isToggled,
  onClick,
  ...props
}: ToggleExpandButtonProps) => (
  <IconButton onClick={onClick} {...props} sx={{ fontSize: "12px", ...props.sx }}>
    <ArrowIcon up={isToggled} down={!isToggled} sx={{ fontSize: "inherit" }} />
  </IconButton>
);

export default ToggleExpandButton;
